export { default } from './ChangePassword';



// WEBPACK FOOTER //
// ./src/components/UserAccount/ChangePassword/index.js